import {OrderableStatusModel} from '@matchsource/models/order-shared';

export type SourceType = 'DONOR' | 'CORD' | 'BDP';
export type SourceCoreModelType = 'cord' | 'donor' | 'bdp' | '';

export interface SourceCoreModel {
  bpGuid: MsApp.Guid;
  id: MsApp.Guid;
  productType: string;
  type: SourceCoreModelType;
  status: string;
  statusOverride?: string;
  previousCT: string;
}

export interface SourceBaseModel extends SourceCoreModel {
  age: number;
  bLeader: string;
  bloodTypeCode: string;
  bloodTypeRh: string;
  bpId: string;
  bpName: string;
  cmv: string;
  cmvDate: string;
  contactType: string;
  country: string;
  countryCode: string;
  countryName: string;
  doingBusinessAsName: string;
  ebsMissing: boolean;
  ethnicity: string;
  ethnicityCode: string;
  grid: MsApp.Guid;
  guid: MsApp.Guid;
  guidPart: MsApp.Guid;
  isWmda: boolean;
  lastContactDate: string;
  list: string;
  localId: string;
  orderableStatus?: OrderableStatusModel;
  orderable: boolean;
  orderableForCmOnly: boolean;
  orderableReasons: string[];
  orderableRecipientClosed: boolean;
  orderableSameDayOrder: boolean;
  duplicateRecipient: boolean;
  pendingAnotherRequest: boolean;
  pendingThisRequest: boolean;
  pregnancies: number | string;
  broadRace: string;
  race: string;
  races: string[];
  ref: number;
  regDate: string;
  restricted: boolean;
  rh: string;
  sex: string;
  statusClass: string;
  statusLabel: string;
  weight: string | number;
  plasmaReduced: string;
  isEmdisCoop: boolean;
  birthDate: string;
  isWmdaOrderable: boolean;
}

export interface SourceListModel {
  id: MsApp.Guid;
  pid: string;
  ref: number;
  grid: string;
  localId: string;
  status: string;
  statusOverride?: string;
  statusClass: string;
  statusLabel: string;
  age: number;
  sex: string;
  rh: string;
  bloodTypeCode: string;
  bloodTypeRh: string;
  cmv?: string;
  cmvDate: string;
  pregnancies?: string | number;
  weight: string | number;
  primaryRaceCode: string;
  broadRace: string;
  race: string;
  races: any;
  ethnicityCode: string;
  ethnicity: string;
  regDate: string;
  bpGuid: string;
  bpId: string;
  bpName: string;
  doingBusinessAsName: string;
  country: string;
  countryCode: string;
  countryName: string;
  previousCT: string;
  lastContactDate: string;
  contactType: string;
  productType: string;
  list: string;
  orderableStatus?: OrderableStatusModel;
  orderable: boolean;
  orderableReasons: string[];
  orderableForCmOnly: boolean;
  orderableSameDayOrder: boolean;
  orderableRecipientClosed: boolean;
  duplicateRecipient: boolean;
  isWmda: boolean;
  isEmdisCoop: boolean;
  guidPart: string;
  guid: MsApp.Guid;
  orderNum?: number;
  ptr?: any;
  pendingThisRequest: boolean;
  pendingAnotherRequest: boolean;
  availabilityDate: string;
  availableDate?: MsApp.DateString;
  type: SourceTypes;
  previousDonation?: number;
  birthDate: string;
  raceEth: string;
  list_bpId: string;
  age_sex: string;
  lastContactDate_contactType: string;
  cmv_bloodTypeRh?: string;
  pregnancies_previousCT?: string;
  availabilityDate_regDate: string;
  seq?: number;
  populationCode: string;
  matching: any;
  wmdaData?: WmdaDonorData;
  displayGrid?: MsApp.Guid;
  tncWeight: string | number;
  cd34FCWeight: string | number;
  tncFrozen: number;
  cd34FrozenCell: number;
  licenseStatus: string;
  seg: number;
  hgb: string;
  hgbTranslated: string;
  nrbc: number;
  matCatg8: number;
  matCatg6: number;
  finalProdVol: number;
  cordCenterIdentifier?: string;
  DOB_SEX: string;
  M_CAT_GROUPED: string;
  tncWeight_cd34FCWeight: string;
  tncFrozen_cd34FrozenCell: string;
  final_prod_vol_ABO_RH: string;
  previousCT_licensure: string;
  hgb_nRBC: string;
  nrbcFormatted: string;
  hgbFormatted: string;
  availabilityDate_of_seg: string;
  dpb1TCEMatch_ccr5: string;
  eligibilityCode: string;
  CordListModel?: string;
  plasmaReduced: string;
  rbcReduced: string;
  ccr5Genotype?: string;
  isWmdaOrderable: boolean;
}

export enum SourceTypes {
  Donor = 'donor',
  Cord = 'cord',
  Biobank = 'bdp',
}

export interface WmdaDonorData {
  requestStatus: string;
  requestDate: MsApp.DateString;
  requestDateAsDate: MsApp.DateTimeString;
  requestedDate: MsApp.DateString;
  resultsReceivedDate: MsApp.DateString;
}

export enum SourceList {
  Nmdp = 'NMDP',

  Wmda = 'WMDA',

  Coop = 'COOP',
}
